<template>
    <div class="main">
        <c-panel title="RECLASSIFICAÇÃO" titleIcon="fas fa-level-up-alt">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Avanço leva o aluno à etapa superior; aceleração corrige distorção idade-série. O fluxo é: abrir → deferir → efetivar. Só se efetiva o que foi deferido."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="8"><el-input v-model="filtro.nome" placeholder="Nome do aluno" @keyup.native.enter="carregar"></el-input></el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.situacao" clearable placeholder="Situação" style="width: 100%;" @change="carregar">
                        <el-option value="em_analise" label="Em análise"></el-option>
                        <el-option value="deferido" label="Deferida"></el-option>
                        <el-option value="indeferido" label="Indeferida"></el-option>
                        <el-option value="efetivado" label="Efetivada"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5">
                    <el-select v-model="filtro.tipo" clearable placeholder="Tipo" style="width: 100%;" @change="carregar">
                        <el-option value="avanco" label="Avanço"></el-option>
                        <el-option value="aceleracao" label="Aceleração"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <el-button v-if="podeEscrever" type="primary" @click="abrirNova">NOVA RECLASSIFICAÇÃO</el-button>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Aluno</th>
                            <th class="hidden-mobile">De → Para</th>
                            <th class="u-text-center" style="width: 90px;">Tipo</th>
                            <th class="u-text-center" style="width: 90px;">Avaliação</th>
                            <th class="u-text-center" style="width: 100px;">Situação</th>
                            <th class="u-text-center" style="width: 230px;">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="r in items" :key="r.id">
                            <td>{{ r.matricula_origem ? r.matricula_origem.nome_aluno : '—' }}</td>
                            <td class="hidden-mobile">
                                {{ r.curso_origem ? r.curso_origem.nome : '—' }} → {{ r.curso_destino ? r.curso_destino.nome : '—' }}
                            </td>
                            <td class="u-text-center">{{ r.tipo === 'avanco' ? 'Avanço' : 'Aceleração' }}</td>
                            <td class="u-text-center">{{ r.data_avaliacao | data }}</td>
                            <td class="u-text-center">{{ rotulo(r.situacao) }}</td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever && r.situacao === 'em_analise'" @click="deferir(r)" type="success" size="mini" plain>DEFERIR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever && r.situacao === 'em_analise'" @click="abrirIndeferir(r)" type="danger" size="mini" plain>INDEFERIR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever && r.situacao === 'deferido'" @click="abrirEfetivar(r)" type="primary" size="mini" plain>EFETIVAR</el-button>
                                <el-button class="u-ml-10" @click="imprimir(r.id)" icon="el-icon-printer" size="mini" plain title="Imprimir ata"></el-button>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhuma reclassificação registrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <el-dialog title="Nova reclassificação" :visible.sync="dialogo" width="640px">
                <el-form label-position="top" class="u-mt-20">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Escola">
                                <el-select v-model="selEscola" filterable style="width: 100%;" @change="carregarTurmas">
                                    <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Período letivo">
                                <el-select v-model="selPeriodo" style="width: 100%;" @change="carregarTurmas">
                                    <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Turma atual do aluno">
                                <el-select v-model="selTurma" filterable placeholder="Selecione a turma"
                                    style="width: 100%;" @change="carregarAlunos">
                                    <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="rotuloTurma(t)"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Aluno">
                                <el-select v-model="form.matricula_origem_id" filterable
                                    placeholder="Selecione o aluno" :disabled="!selTurma" style="width: 100%;">
                                    <el-option v-for="m in alunos" :key="m.id" :value="m.id"
                                        :label="m.nome_aluno + (m.num_matricula ? ' — ' + m.num_matricula : '')"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="12">
                            <el-form-item label="Tipo">
                                <el-select v-model="form.tipo" style="width: 100%;">
                                    <el-option value="avanco" label="Avanço"></el-option>
                                    <el-option value="aceleracao" label="Aceleração"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12">
                            <el-form-item label="Data da avaliação">
                                <el-date-picker v-model="form.data_avaliacao" type="date" value-format="yyyy-MM-dd"
                                    format="dd/MM/yyyy" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="12">
                            <el-form-item label="Curso de destino">
                                <el-select v-model="form.curso_destino_id" filterable style="width: 100%;">
                                    <el-option v-for="c in cursos" :key="c.id" :value="c.id" :label="c.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12">
                            <el-form-item label="Motivo">
                                <el-select v-model="form.motivo_id" clearable style="width: 100%;">
                                    <el-option v-for="m in motivos" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Parecer da comissão">
                        <el-input v-model="form.parecer_comissao" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvar">ABRIR PROCESSO</el-button>
                </span>
            </el-dialog>

            <el-dialog title="Efetivar reclassificação" :visible.sync="dialogoEf" width="520px">
                <el-form label-position="top">
                    <el-alert type="warning" :closable="false" class="u-mb-15"
                        title="Ao efetivar, a matrícula atual passa a RECLASSIFICADO e uma nova matrícula ativa é criada na turma de destino. A ata é gerada automaticamente."></el-alert>
                    <el-form-item label="Turma de destino">
                        <el-select v-model="efTurma" filterable placeholder="Selecione a turma" style="width: 100%;">
                            <el-option v-for="t in turmasDestino" :key="t.id" :value="t.id" :label="rotuloTurma(t)"></el-option>
                        </el-select>
                        <small v-if="turmasDestino.length === 0">
                            Nenhuma turma do curso de destino nesta escola e período letivo.
                        </small>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoEf = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="efetivar">EFETIVAR</el-button>
                </span>
            </el-dialog>

            <el-dialog title="Indeferir reclassificação" :visible.sync="dialogoInd" width="520px">
                <el-form label-position="top">
                    <el-form-item label="Parecer da comissão">
                        <el-input v-model="parecerInd" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="dialogoInd = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="danger" @click="indeferir">INDEFERIR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO E — item 56: reclassificação por avanço ou aceleração. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    filters: { data (v) { return v ? String(v).substring(0, 10).split('-').reverse().join('/') : '—' } },
    data: () => ({
        statusList: false, filtro: { nome: '', situacao: '', tipo: '' }, items: [],
        cursos: [], motivos: [],
        instituicoes: [], turmas: [], alunos: [], turmasDestino: [],
        selEscola: null, selPeriodo: null, selTurma: null,
        dialogo: false, dialogoEf: false, dialogoInd: false,
        atual: null, efTurma: null, parecerInd: '',
        form: { matricula_origem_id: '', tipo: 'avanco', curso_destino_id: null, motivo_id: null,
                data_avaliacao: '', parecer_comissao: '' }
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.cursos = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.motivos = (r.data && r.data.motivos) ? r.data.motivos : [] }).catch(() => {})

        this.selPeriodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.selEscola = inst.id }
        else {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }

        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        rotulo (s) {
            return { em_analise: 'Em análise', deferido: 'Deferida', indeferido: 'Indeferida', efetivado: 'Efetivada' }[s] || s
        },
        rotuloTurma (t) {
            const turnos = { 0: 'Matutino', 1: 'Vespertino', 2: 'Noturno', 4: 'Integral' }
            return t.nome + (t.curso ? ' — ' + t.curso.nome : '') + (turnos[t.turno] ? ' · ' + turnos[t.turno] : '')
        },
        /** Turmas da escola e período escolhidos — o aluno vem da turma. */
        carregarTurmas () {
            this.turmas = []
            this.alunos = []
            this.selTurma = null
            this.form.matricula_origem_id = null
            if (!this.selEscola || !this.selPeriodo) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.selEscola}/${this.selPeriodo}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() })
             .catch(e => this.$store.commit('throwException', e))
        },
        carregarAlunos () {
            this.alunos = []
            this.form.matricula_origem_id = null
            if (!this.selTurma) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.selTurma}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alunos = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        abrirNova () {
            this.form = { matricula_origem_id: null, tipo: 'avanco', curso_destino_id: null, motivo_id: null,
                data_avaliacao: '', parecer_comissao: '' }
            this.turmas = []
            this.alunos = []
            this.selTurma = null
            if (this.selEscola && this.selPeriodo) this.carregarTurmas()
            this.dialogo = true
        },
        salvar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/store`,
                this.form, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Processo aberto.', type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        deferir (r) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/deferir/${r.id}`,
                {}, this.$store.getters.getHeaderAuth
            ).then(res => {
                if (res.data && res.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(res.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Reclassificação deferida.', type: 'success' })
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirIndeferir (r) { this.atual = r; this.parecerInd = ''; this.dialogoInd = true },
        indeferir () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/indeferir/${this.atual.id}`,
                { parecer_comissao: this.parecerInd }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Reclassificação indeferida.', type: 'success' })
                this.dialogoInd = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        /** Turmas elegíveis: as do CURSO DE DESTINO, na escola e período da matrícula. */
        abrirEfetivar (r) {
            this.atual = r
            this.efTurma = r.turma_destino_id || null
            this.turmasDestino = []
            this.dialogoEf = true

            const inst = r.matricula_origem ? r.matricula_origem.instituicao_id : null
            const periodo = this.selPeriodo || (this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null)
            if (!inst || !periodo) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${inst}/${periodo}`,
                this.$store.getters.getHeaderAuth
            ).then(res => {
                const todas = Array.isArray(res.data) ? res.data : Object.values(res.data || {}).flat()
                this.turmasDestino = todas.filter(t => parseInt(t.curso_id) === parseInt(r.curso_destino_id))
            }).catch(() => {})
        },
        efetivar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/reclassificacao/efetivar/${this.atual.id}`,
                { turma_destino_id: this.efTurma }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.dialogoEf = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir (id) { window.eventBus.$emit('print', { url: '/api/reclassificacao/imprimirAta/' + id, param: null }) },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
